module.exports = __webpack_public_path__ + "img/5.7818f809.png";